@if (cameras && cameras.list.length) {
  <div class="component-list">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Camera</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (camera of cameras.list; track camera) {
          <tr class="title">
            <td>{{camera.title}} </td>
            <td><i [routerLink]="['/camera', camera.id, 'control']" class="fa fa-cog"></i></td>
          </tr>
          <tr class="images">
            <td>
              @for (preset of camera.presets; track preset) {
                @if (preset.shotNight || preset.recentBucketKey) {
                  <div class="shots">
                    <app-camera-shot [camera]="camera" [preset]="preset"></app-camera-shot>
                  </div>
                }
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (!cameras) {
  <div class="loader">Loading...</div>
}
@if (cameras && !cameras.list.length) {
  <div>
    <div class="col-md-12 nothing-returned">
      <h3>Your organisation has no timelapse devices</h3>
      <div>
        <i class="fa fa-frown-o"></i>
      </div>
      <div class="find-out-more">
        <a target="_blank" href="https://4dmonitoring.co.uk" class="btn btn-primary">Find out more about the 4D timelapse solution &rarr;</a>
      </div>
    </div>
  </div>
}